

const PersonnelListHeader = () => {
  return (
    // <div className='card-header border-0 pt-6'>
    //   {/* <PersonnelListSearchComponent /> */}
    //   {/* begin::Card toolbar */}
    //   <div className='card-toolbar'>
    //     {/* begin::Group actions */}
    //     {/* <PersonnelListToolbar /> */}
    //     {/* end::Group actions */}
    //   </div>
    //   {/* end::Card toolbar */}
    // </div>
    <></>
  )
}

export {PersonnelListHeader}

//not used